export const SYNC_ROW_TAG_CONFIG = {
  changed: {
    label: "Modificado",
    color: "#fa8c16",
    background: "#fff7e6",
    border: "1px solid #fa8c16",
  },
  only_in_dev: {
    label: "Adicionado",
    color: "#0f9f2b",
    background: "#eafbea",
    border: "1px solid #16b83e",
  },
  only_in_prod: {
    label: "Removido",
    color: "#d80404",
    background: "#fff1f0",
    border: "1px solid #d80404",
  },
};
